import dayjs from 'dayjs';

import { IconManager } from '@speeki/icons';

import { TaskCardBaseFragment } from '@graphql/generated/graphql';

import {
    AdditionalLabelDetails,
    DueDate,
    TaskDetails,
    TaskItem,
    TaskText,
    TooltipTitle,
    TooltipWrapper,
} from './TaskTooltipContent.styled';

interface TaskTooltipContentProps {
    count: number;
    tasks: TaskCardBaseFragment[];
    title: string;
}

const DUE_DAY_WARN_DAYS = 7;

export const TaskTooltipContent = ({
    count,
    tasks,
    title,
}: TaskTooltipContentProps) => {
    return (
        <TooltipWrapper as={'span'}>
            <TooltipTitle as={'span'}>
                {title} ({count}):
            </TooltipTitle>
            {tasks.map((task) => {
                const currentDate = dayjs();
                const dueDate = dayjs(task.dueDate);

                const isDueDatePassed = dueDate < currentDate;
                const isDueDateWarning =
                    currentDate < dueDate &&
                    dueDate < currentDate.add(DUE_DAY_WARN_DAYS, 'days');

                const showAdditionalLabel =
                    task.status !== 'CLOSED' &&
                    (isDueDatePassed || isDueDateWarning);

                return (
                    <TaskItem key={task.uuid}>
                        <TaskText as={'span'}>
                            Task ID {task.id}: {task.title}
                        </TaskText>
                        <TaskDetails>
                            <TaskText as={'span'}>
                                Due date{' '}
                                {dayjs(task.dueDate).format('YYYY/MM/DD')}
                            </TaskText>

                            {showAdditionalLabel && (
                                <AdditionalLabelDetails>
                                    <IconManager
                                        icon={'SvgAlert24'}
                                        size={16}
                                        themeColors={{
                                            default: {
                                                'color-1': isDueDatePassed
                                                    ? 'semantic.error'
                                                    : 'priority.medium',
                                            },
                                        }}
                                    />
                                    <DueDate
                                        as={'span'}
                                        isDueDatePassed={isDueDatePassed}
                                    >
                                        {isDueDatePassed
                                            ? 'Overdue'
                                            : 'Due soon'}
                                    </DueDate>
                                </AdditionalLabelDetails>
                            )}
                        </TaskDetails>
                    </TaskItem>
                );
            })}
            {tasks.length < count && (
                <TaskText as={'span'}>
                    ... +{count - tasks.length} more
                </TaskText>
            )}
        </TooltipWrapper>
    );
};
